import React, { useContext } from 'react';
import { ShippingBanner } from '../components/ShippingBanner';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { NavigationContext } from '../App';
import { ArrowRight } from 'lucide-react';
// Product images from Christiana's collection
const IMAGES = {
  blackPeplum: 'https://cdn.magicpatterns.com/uploads/k3nbovxYYDH3962AQgD28u/photo_2026-02-04_04-57-03.jpg',
  brownPleated: 'https://cdn.magicpatterns.com/uploads/dyohvQLDScUhskTJ884wYi/photo_2026-02-04_04-57-01.jpg',
  purpleFringe: 'https://cdn.magicpatterns.com/uploads/rrAJzJnT1RaD9iNVi3fG4e/photo_2026-02-04_04-57-00.jpg',
  tealSuit: 'https://cdn.magicpatterns.com/uploads/3hrnMEGcTHukVuERpb86Hi/photo_2026-02-04_04-57-05.jpg',
  greenMaxi: 'https://cdn.magicpatterns.com/uploads/n3jybvjJ42ADZp6V5BmhiN/photo_2026-02-04_04-57-04.jpg'
};
const collections = [{
  id: 1,
  name: 'Evening Elegance',
  description: 'Stunning pieces for your special occasions',
  image: IMAGES.blackPeplum,
  itemCount: 12
}, {
  id: 2,
  name: 'Everyday Chic',
  description: 'Effortless style for daily wear',
  image: IMAGES.brownPleated,
  itemCount: 18
}, {
  id: 3,
  name: 'Bold & Beautiful',
  description: 'Statement pieces that turn heads',
  image: IMAGES.purpleFringe,
  itemCount: 8
}, {
  id: 4,
  name: 'Power Suits',
  description: 'Commanding presence for the modern woman',
  image: IMAGES.tealSuit,
  itemCount: 6
}];
export function CollectionsPage() {
  const {
    navigate
  } = useContext(NavigationContext);
  return <div className="min-h-screen flex flex-col bg-[#FDF8F3]" data-id="element-753">
      <ShippingBanner data-id="element-754" />
      <Navbar data-id="element-755" />

      <main className="flex-grow" data-id="element-756">
        {/* Hero Section */}
        <section className="py-16 sm:py-20 text-center px-4" data-id="element-757">
          <h1 className="text-5xl sm:text-6xl md:text-7xl font-['Playfair_Display'] text-[#5C3D2E] mb-4" data-id="element-758">
            Our Collections
          </h1>
          <div className="w-14 h-[2px] bg-[#D4A853] mx-auto mb-6" data-id="element-759" />
          <p className="text-lg sm:text-xl text-[#6B5B4F] font-['Raleway'] max-w-2xl mx-auto leading-relaxed" data-id="element-760">
            Explore our carefully curated collections, each telling a unique
            story of African elegance and modern sophistication.
          </p>
        </section>

        {/* Collections Grid */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24" data-id="element-761">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-762">
            {collections.map((collection, index) => <div key={collection.id} onClick={() => navigate('shop')} className={`group relative overflow-hidden cursor-pointer ${index === 0 ? 'md:col-span-2 aspect-[2/1]' : 'aspect-[4/5]'}`} data-id="element-763">
                <img src={collection.image} alt={collection.name} className="w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105" data-id="element-764" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#5C3D2E]/90 via-[#5C3D2E]/40 to-transparent" data-id="element-765" />

                <div className="absolute bottom-0 left-0 w-full p-8 lg:p-12" data-id="element-766">
                  <p className="text-sm text-[#D4A853] uppercase tracking-[0.2em] mb-2 font-['Raleway']" data-id="element-767">
                    {collection.itemCount} pieces
                  </p>
                  <h2 className="text-3xl sm:text-4xl lg:text-5xl font-['Playfair_Display'] text-white mb-3" data-id="element-768">
                    {collection.name}
                  </h2>
                  <p className="text-lg text-white/80 font-['Raleway'] mb-6 max-w-md" data-id="element-769">
                    {collection.description}
                  </p>
                  <div className="inline-flex items-center text-base font-medium text-[#D4A853] uppercase tracking-[0.15em] group-hover:text-white transition-colors" data-id="element-770">
                    Explore Collection
                    <ArrowRight size={18} className="ml-2 transform group-hover:translate-x-1 transition-transform" strokeWidth={1.5} data-id="element-771" />
                  </div>
                </div>

                {/* Decorative corner */}
                <div className="absolute top-6 right-6 w-12 h-12 border-t-2 border-r-2 border-[#D4A853]/50 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-772" />
              </div>)}
          </div>
        </section>

        {/* Featured Collection CTA */}
        <section className="py-20 bg-[#5C3D2E] text-white relative" data-id="element-773">
          <div className="absolute top-0 left-0 right-0 h-1.5 kente-stripe" data-id="element-774" />
          <div className="absolute inset-0 african-pattern opacity-10" data-id="element-775" />
          <div className="relative max-w-4xl mx-auto text-center px-4" data-id="element-776">
            <p className="text-sm uppercase tracking-[0.2em] text-[#D4A853] mb-4 font-['Raleway']" data-id="element-777">
              New Season
            </p>
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-['Playfair_Display'] mb-6" data-id="element-778">
              Spring/Summer 2025
            </h2>
            <p className="text-lg sm:text-xl text-white/70 font-['Raleway'] mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-779">
              Discover our latest collection featuring vibrant colors, bold
              patterns, and timeless silhouettes inspired by African heritage.
            </p>
            <Button onClick={() => navigate('shop')} variant="secondary" className="h-14 px-10 text-base bg-[#D4A853] text-[#1A1A1A] hover:bg-[#E8C97A]" data-id="element-780">
              Shop New Arrivals
            </Button>
          </div>
        </section>
      </main>

      <Footer data-id="element-781" />
    </div>;
}